export default __webpack_public_path__ + "static/media/paging_last.6894f8b4.svg";